import React from 'react';
import { Input } from 'baseui/input';
import { Button } from 'baseui/button';
import { Card, StyledBody } from 'baseui/card';
import { HeadingSmall, LabelMedium, ParagraphMedium } from 'baseui/typography';
import useFindUserBucket from './useFindUserBucket';

const FindUserBucket: React.FC<{}> = () => {
	const { experimentName, userId, setUserId, loading, result, handleLookup, handleBack } = useFindUserBucket();

	return (
		<div style={{ padding: '24px', maxWidth: '600px' }}>
			<HeadingSmall>Find User Bucket</HeadingSmall>
			<ParagraphMedium>
				Experiment: <strong>{experimentName}</strong>
			</ParagraphMedium>

			<div style={{ marginBottom: '16px' }}>
				<LabelMedium>Zupee User ID</LabelMedium>
				<Input
					value={userId}
					onChange={(e) => setUserId((e.target as HTMLInputElement).value)}
					placeholder='Enter Zupee User ID'
					disabled={loading}
					onKeyDown={(e) => {
						if (e.key === 'Enter') handleLookup();
					}}
				/>
			</div>

			<div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
				<Button onClick={handleLookup} isLoading={loading}>
					Lookup Bucket
				</Button>
				<Button onClick={handleBack} kind='secondary'>
					Back
				</Button>
			</div>

			{result && (
				<Card>
					<StyledBody>
						<LabelMedium>
							Bucket: <strong>{result.bucketName}</strong>
						</LabelMedium>
					</StyledBody>
				</Card>
			)}
		</div>
	);
};

export default FindUserBucket;
